import { ReactComponent as StatusErrorSVG } from '../assets/images/status-error.svg';

const StatusError = () => {
  return <StatusErrorSVG className="text-error-red" />;
}

export default StatusError;
